module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.7@readable-stream/passthrough.js
// module id = 757
// module chunks = 0